import React, { useContext, useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Button from "../ui/Button";
import Wallet from "../../assets/icons/wallet.svg?react";
import WalletPopup from "../Popup/WalletPopup";
import { NavigationContext } from "../../context/NavigationContext";

import { walletApi } from "../../api/wallet";
import { useAuth } from "../../context/AuthContext";
import { useWebSocket } from "../../context/WebSocketContext";

export default function HeaderWithIcon({ address = -1, title }) {
  const [showPopup, setShowPopup] = useState(false);
  const [balance, setBalance] = useState(0);
  const { tokens, user } = useAuth();
  const { refreshWalletBalance } = useWebSocket();

  useEffect(() => {
    const fetchBalance = async () => {
      const wallet = await walletApi.getWallet(tokens.access.token, user.id);
      setBalance(wallet.balance);
    };
    fetchBalance();
  }, [refreshWalletBalance]);

  useEffect(() => {
    const handleWalletRefresh = async () => {
      const wallet = await walletApi.getWallet(tokens.access.token, user.id);
      setBalance(wallet.balance);
    };

    window.addEventListener('walletRefresh', handleWalletRefresh);

    return () => {
      window.removeEventListener('walletRefresh', handleWalletRefresh);
    };
  }, [tokens, user]);

  // const { setIsBackNavigation } = useContext(NavigationContext);
  // const navigate = useNavigate();

  // const handleBack = () => {
  //   setIsBackNavigation(true); // Mark navigation as "back"
  //   navigate(address);
  // };

  const { handleNavigate } = useContext(NavigationContext);
  const navigate = useNavigate();

  return (
    <>
      <div className="flex items-center pt-8 px-5 mb-3">
        {/* Back Button */}
        {/* <button className="text-gray-600" onClick={() => navigate(address)}>
          <ChevronLeft className="h-6 w-6" />
        </button> */}

        {/* Back Button with Animation */}
        <motion.button
          className="text-gray-600"
          onClick={() => handleNavigate(address, true, navigate)} // Use handleNavigate with back navigation
          whileHover={{ scale: 1.1 }} // Slightly enlarge on hover
          whileTap={{ scale: 0.9 }} // Shrink on click
          initial={{ x: 0 }} // Start at the default position
          animate={{ x: [0, -5, 0] }} // Slight bounce effect when rendered
          transition={{ duration: 0.3 }} // Timing for the bounce
        >
          <ChevronLeft className="h-6 w-6" />
        </motion.button>

        {/* Form Title */}
        <div className="flex items-center justify-between w-full px-2">
          <h1 className="text-gray-800 text-base font-bold font-poppins flex-grow  ">
            {title}
          </h1>

          <Button
            text={`${Intl.NumberFormat('en-US', { style: 'currency', currency: 'PHP' }).format(balance)}`}
            className="text-[#0E64D1] bg-transparent font-medium rounded-[4px] text-sm  px-1 py-0.5   border border-[#0E64D1]"
            icon={Wallet} // Pass the Wallet SVG as the icon prop
            onClick={() => setShowPopup(true)}
          />
        </div>
      </div>

      <WalletPopup
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        currentBalance={balance}
      />
    </>
  );
}
